import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useStatistics() {
  const [loading, setLoading] = useState(true);
  const [statistics, setStatistics] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.affiliates.statistics.index)
      .then((response) => {
        setStatistics(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, statistics };
}
